import React from 'react';
import styled from 'styled-components';
import { Popover } from 'antd';
import { QuestionCircleOutlined, PlusOutlined } from '@ant-design/icons';
import Button from 'components/forms/Button';
import WideInputWithSelectRow from './WideInputWithSelectRow';
import TotalRow from './TotalRow';
import FormRow from './FormRow';
import InputLabel from '../common/InputLabel';

const ToggleHeader = styled.label`
    display: inline-flex;
    justify-content: space-between;
    font-size: 1.4em;
`;

const TooltipIcon = styled(QuestionCircleOutlined)`
    margin-left: 0.3em;
`;

const AdditionalSpend = ({
    onInputNameChange,
    onInputChange,
    onSelectChange,
    onAddRow,
    onToggleWashChange,
    onToggleCommissionChange,
    formData,
    removeItem,
    currency,
    selectStyles,
}) => (
    <div>
        <FormRow
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                marginBottom: '0.5em',
            }}
        >
            <InputLabel style={{ width: '20%' }} />
            <InputLabel
                style={{
                    width: '15%',
                    marginRight: '1em',
                    textAlign: 'center',
                }}
                text="Total Spend"
            />
            <InputLabel
                style={{
                    width: '20%',
                    textAlign: 'center',
                    marginRight: '1em',
                }}
                text="Profit Margin"
            />
            <div className="grpDisp-form-toggle-block">
                {formData.groupWash && (
                    <ToggleHeader>
                        <InputLabel
                            style={{
                                width: '100%',
                                textAlign: 'center',
                                fontSize: '1em',
                            }}
                            text="Wash"
                        />
                        <Popover
                            placement="right"
                            content={
                                <>
                                    Apply this if you would like to reduce the groups additional spend based on the
                                    estimated wash or cancellations expected.
                                    <br />
                                    Eg. If the group is expected to reduce by 10%, would 10% be taken off their expected
                                    spend? <br />
                                    This may not be the case for Room Hire (as an example) but may reduce for F&B
                                </>
                            }
                            trigger="click"
                        >
                            <TooltipIcon />
                        </Popover>
                    </ToggleHeader>
                )}

                {formData.groupCommission && (
                    <ToggleHeader>
                        <InputLabel
                            style={{
                                width: '100%',
                                textAlign: 'center',
                                fontSize: '1em',
                            }}
                            text="Com."
                        />
                        <Popover
                            placement="right"
                            content={<>Apply this if you would like us to deduct commission from this total</>}
                            trigger="click"
                        >
                            <TooltipIcon />
                        </Popover>
                    </ToggleHeader>
                )}
            </div>

            <InputLabel style={{ width: '20%', textAlign: 'center' }} text="Nett profit" />
        </FormRow>

        {formData.additionalSpend.map((row) => (
            <WideInputWithSelectRow
                id={row.id}
                editableTitle={!row.isPreset}
                title={row.name}
                onChangeTitle={onInputNameChange}
                name={row.name}
                grossValue={row.value}
                onChangeGrossValue={onInputChange}
                profitMargin={row.percentage}
                onChangeMargin={onSelectChange}
                netProfit={row.amount}
                showWashToggle={formData.groupWash}
                onToggleWashChange={onToggleWashChange}
                applyWash={row.applyWash}
                showCommissionToggle={formData.groupCommission}
                onToggleCommissionChange={onToggleCommissionChange}
                applyCommission={row.applyCommission}
                showDeleteIcon
                removeItem={removeItem}
                currency={currency}
                selectStyles={selectStyles}
            />
        ))}
        <Button style={{ marginTop: '2em' }} size="large" icon={<PlusOutlined />} onClick={onAddRow}>
            Add
        </Button>
        <TotalRow formData={formData} currency={currency} />
    </div>
);

export default AdditionalSpend;
